<template>
  <div class="financialAuditDetail">
    <van-form label-width="120px">
      <div v-if="form.PaymentType == 1">
        <div class="title">{{ $t.meta.basicTitle }}</div>
        <van-field
          v-model="form.PaymentRecordNumber"
          :label="$t.financialRequest.paymentRecordNumber"
          readonly
        />
        <van-field
          v-model="form.UserName"
          :label="$t.financialRequest.applicant"
          readonly
        />
        <van-field
          v-model="form.Department"
          :label="$t.financialRequest.department"
          readonly
        />
        <van-field
          v-model="form.SubmitTime"
          :label="$t.financialRequest.submitTime"
          readonly
        />
        <van-field
          v-model="form.SubmitCount"
          :label="$t.financialRequest.submitCount"
          readonly
        />
        <van-field
          v-model="approvalState"
          :label="$t.financialRequest.approvalState"
          readonly
        />
        <van-field
          v-model="form.TotalBatch"
          :label="$t.financialRequest.totalBatch"
          readonly
        />

        <div class="title">{{ $t.financialRequest.dTitle1 }}</div>

        <van-field
          v-model="form.CustomerName"
          :label="$t.financialRequest.supplierName"
          readonly
        />

        <van-field
          v-model="form.SupplierVoucherNumber"
          :label="$t.financialRequest.voucherNumber"
          readonly
        />

        <van-field
          v-model="paymentState"
          :label="$t.financialRequest.paymentState"
          readonly
        />

        <van-field
          v-model="form.PaymentSystemCode"
          :label="$t.financialRequest.systemCode"
          readonly
        />

        <van-field
          v-model="form.LatestPaymentDate"
          :label="$t.financialRequest.lastDate"
          readonly
        />

        <div
          class="subTotal"
          v-if="form.PaidAmountList && form.PaidAmountList.length > 0"
        >
          <div class="subTotal-label">{{ $t.financialRequest.payAmount }}</div>
          <div
            class="subTotal-item"
            v-for="(item, index) in form.PaidAmountList"
            :key="index"
          >
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.TotalAmount }}</div>
          </div>
        </div>

        <van-field
          v-model="form.PaymentVoucherUploadDate"
          :label="$t.financialRequest.uploadDate"
          readonly
        />

        <van-field
          v-model="form.NuclearAccountNo"
          :label="$t.financialRequest.creditRefNo"
          readonly
        />

        <div class="multi-table" v-if="payments1">
          <van-field name="stepper" :label="$t.financialRequest.payReceipt">
            <template #input>
              <van-stepper :min="0" :value="payments1.length" :disabled="true" />
            </template>
          </van-field>
          <div v-for="(item, index) in payments1" :key="index">
            <van-field :label="'No.' + (index + 1)">
              <template #input>
                <van-image
                  :src="item.PaymentVoucher && imgUrlFilter(item.PaymentVoucher)"
                  @click="imagePreview(imgUrlFilter(item.PaymentVoucher))"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.PaymentVoucher"
                ></van-image>
              </template>
            </van-field>
          </div>
        </div>

        <!-- 查看 -->
        <div style="margin: 16px" v-if="form.TodoList != 1">
          <van-button round block type="default" @click="toPayrollDetail">{{
            $t.financialRequest.button5
          }}</van-button>
        </div>
      </div>
      <div v-if="form.PaymentType == 2">
        <div class="title">{{ $t.meta.basicTitle }}</div>
        <van-field
          v-model="form.OperationRecordNumber"
          :label="$t.financialRequest.paymentRecordNumber"
          readonly
        />
        <van-field
          v-model="form.UserName"
          :label="$t.financialRequest.applicant"
          readonly
        />
        <van-field
          v-model="form.Department"
          :label="$t.financialRequest.department"
          readonly
        />
        <van-field
          v-model="form.SubmitTime"
          :label="$t.financialRequest.submitTime"
          readonly
        />
        <van-field
          v-model="form.SubmitCount"
          :label="$t.financialRequest.submitCount"
          readonly
        />
        <van-field
          v-model="approvalState"
          :label="$t.financialRequest.approvalState"
          readonly
        />
        <van-field
          v-model="form.TotalBatch"
          :label="$t.financialRequest.totalBatch"
          readonly
        />

        <div class="title">{{ $t.financialRequest.dTitle2 }}</div>
        <van-field
          v-model="form.SubCategoryName"
          :label="$t.financialRequest.costCate"
          readonly
        />
        <van-field
          v-model="form.FeeAmount"
          :label="$t.financialRequest.costAmount"
          readonly
        />
        <van-field v-model="form.CurrencySn" :label="$t.meta.currency" readonly />
        <van-field
          v-model="paymentMethod"
          :label="$t.financialRequest.menthodState"
          readonly
        />
        <van-field
          v-model="paymentState"
          :label="$t.financialRequest.paymentState"
          readonly
        />
        <van-field
          v-model="form.PaymentSystemCode"
          :label="$t.financialRequest.systemCode"
          readonly
        />

        <van-field
          v-model="form.PaymentVoucherUploadDate"
          :label="$t.financialRequest.uploadDate"
          readonly
        />

        <div class="multi-table" v-if="payments2">
          <van-field name="stepper" :label="$t.financialRequest.requestReceipt">
            <template #input>
              <van-stepper :min="0" :value="payments2.length" :disabled="true" />
            </template>
          </van-field>
          <div v-for="(item, index) in payments2" :key="index">
            <van-field :label="'No.' + (index + 1)">
              <template #input>
                <van-image
                  :src="item.VoucherFile && imgUrlFilter(item.VoucherFile)"
                  @click="imagePreview(imgUrlFilter(item.VoucherFile))"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.VoucherFile"
                ></van-image>
              </template>
            </van-field>
          </div>
        </div>

        <div class="multi-table" v-if="payments3">
          <van-field name="stepper" :label="$t.financialRequest.payReceipt">
            <template #input>
              <van-stepper :min="0" :value="payments3.length" :disabled="true" />
            </template>
          </van-field>
          <div v-for="(item, index) in payments3" :key="index">
            <van-field :label="'No.' + (index + 1)">
              <template #input>
                <van-image
                  :src="item.VoucherFile && imgUrlFilter(item.VoucherFile)"
                  @click="imagePreview(imgUrlFilter(item.VoucherFile))"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.VoucherFile"
                ></van-image>
              </template>
            </van-field>
          </div>
        </div>

        <!-- 查看 -->
        <div style="margin: 16px" v-if="form.TodoList != 1">
          <van-button round block type="default" @click="toPayrollRequest">{{
            $t.financialRequest.button6
          }}</van-button>
        </div>
      </div>
    </van-form>

    <div class="tool-bar" v-if="form.PaymentType == 1">
      <!-- 审批 -->
      <van-button type="info" block @click="toPayrollDetail" v-if="form.TodoList == 1">{{
        $t.financialRequest.button3
      }}</van-button>
      <!-- 付款 -->
      <van-button type="danger" block @click="showPcNote" v-if="form.TodoList == 2">{{
        $t.financialRequest.payButton
      }}</van-button>
    </div>
    <div class="tool-bar" v-if="form.PaymentType == 2">
      <!-- 审批 -->
      <van-button type="info" block @click="toPayrollRequest" v-if="form.TodoList == 1">{{
        $t.financialRequest.button4
      }}</van-button>
      <!-- 付款 -->
      <van-button
        type="danger"
        block
        @click="toPayrollPayment"
        v-if="form.TodoList == 2"
        >{{ $t.financialRequest.payButton }}</van-button
      >
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image, Uploader, Picker, Popup, Stepper } from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Uploader)
  .use(Picker)
  .use(Popup)
  .use(Stepper);

export default {
  name: "financialAuditDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {},
      payments1: [],
      payments2: [],
      payments3: [],
      approvalState: "",
      paymentState: "",
      paymentMethod: "",
    };
  },
  created() {
    var data = JSON.parse(localStorage.getItem("financialAuditDetail"));
    this.form = data;
    this.firstLoad();
  },
  methods: {
    showPcNote() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
        title: this.$t.financialRequest.txtButton,
        msg: this.$t.meta.website + " www.vtrack.top",
      });
    },
    toPayrollRequest() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "payrollRequest",
        name: "payrollRequest",
        query: [
          {
            name: "OERId",
            value: this.form.OERId,
          },
          {
            name: "Type",
            value: "detail",
          },
        ],
      });
    },
    toPayrollDetail() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "payrollDetails",
        name: "payrollDetails",
        query: [
          {
            name: "PRAId",
            value: this.form.PRAId,
          },
          {
            name: "Type",
            value: "detail",
          },
        ],
      });
    },
    toPayrollPayment() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "payrollPayment",
        name: "payrollPayment",
        query: [
          {
            name: "OERId",
            value: this.form.OERId,
          },
          {
            name: "Type",
            value: this.form.PaymentType,
          },
        ],
      });
    },
    firstLoad() {
      if (this.form.ApprovalState == 0) {
        this.approvalState = this.$t.financialRequest.aState1;
      }
      if (this.form.ApprovalState == 1) {
        this.approvalState = this.$t.financialRequest.aState2;
      }
      if (this.form.ApprovalState == 2) {
        this.approvalState = this.$t.financialRequest.aState3;
      }
      if (this.form.ApprovalState == 3) {
        this.approvalState = this.$t.financialRequest.aState4;
      }
      if (this.form.ApprovalState == 4) {
        this.approvalState = this.$t.financialRequest.aState5;
      }
      if (this.form.PaymentState == 0) {
        this.paymentState = this.$t.financialRequest.pState1;
      }
      if (this.form.PaymentState == 1) {
        this.paymentState = this.$t.financialRequest.pState2;
      }
      if (this.form.PaymentMethod == 1) {
        this.paymentMethod = this.$t.financialRequest.mState1;
      }
      if (this.form.PaymentMethod == 2) {
        this.paymentMethod = this.$t.financialRequest.mState2;
      }
      if (this.form.PaymentMethod == 3) {
        this.paymentMethod = this.$t.financialRequest.mState3;
      }
      if (this.form.NarId) {
        this.getNuclearAccountPaymentVoucherList();
      }
      if (this.form.OERId) {
        this.getOperatingExpenseVoucherList(1);
        this.getOperatingExpenseVoucherList(2);
      }
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getNuclearAccountPaymentVoucherList() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          NarId: this.form.NarId,
        };
        this.$api.financialManagement
          .getNuclearAccountPaymentVoucherList(param)
          .then((res) => {
            this.payments1 = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    getOperatingExpenseVoucherList(type) {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          VoucherType: type,
          OERId: this.form.OERId,
        };
        this.$api.financialManagement
          .getOperatingExpenseVoucherList(param)
          .then((res) => {
            if (type == 1) {
              this.payments2 = res.data;
            }
            if (type == 2) {
              this.payments3 = res.data;
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.financialAuditDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .subTotal {
    padding: 15px;
    font-size: 14px;
    color: #646566;
    .subTotal-label {
      margin-bottom: 15px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 10px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 10px;
        background: #e8f4ff;
      }
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        width: 70%;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 30%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
